<template>
<div class="grid__content">
	<scrollbar class="statistica_wrap">
        <div class="statistica__content">
            <h1>Стратегия торговли</h1>
            <p>Данная торговая система уникальна и не имеет аналогов на рынке ни по содержанию, ни по результатам. Ее производительность и эффективность подтверждены не одним годом успешной торговой практики. В основе системы лежит набор не зависимых компонентов и алгоритм их взаимодействия, которые в совокупности позволяют получить стабильный финансовый результат.</p>
            <p>Компоненты системы — математическая модель, синтетический индекс, модель определения движения рыночной цены и оценки вероятности работают только с актуальными данными и постоянно обновляются, что делает систему «живой» - неустанно реагирующие и просчитывающей рыночные изменения.</p>
            <!--<div class="read-more">читать полностью <div class="read-more__ico"><i class="mdi mdi-arrow-right"></i></div></div>-->
            <div class="profile_blockWidget profile_blockWidget_mini">
                    <div class="profile_blockWidget-bigIcon">
                        <svg style="width:30px;height:30px" viewBox="0 0 24 24">
                            <path fill="#CAE9FF" d="M5,3C3.89,3 3,3.89 3,5V19C3,20.11 3.89,21 5,21H19C20.11,21 21,20.11 21,19V5C21,3.89 20.11,3 19,3H5M5,5H19V19H5V5M7,7V9H17V7H7M7,11V13H17V11H7M7,15V17H14V15H7Z" />
                        </svg>
                    </div>
                    <div class="profile_blockWidget-text gorizontal">
                        <div class="profile_blockWidget-title profile_blockWidget-title_noBottom">
                            Описание торговой<br>стратегии
                        </div>
                        <div class="profile_blockWidget-ico">
                            <a href="http://master.forexinvest.com/files/strategy.pdf" target="_blank">
                                <i class="icon-download"></i>
                            </a>
                        </div>
                    </div>
                </div>
        </div>
        <div class="statistica_wrap">
        <tabs
            :classNavigation = "'tabs-navigation-statistic'">
            <tab :name="'Основное'" :selected="true">
                <div class="statistica_wrap">
                    <summary-table></summary-table>
                </div>
            </tab>
            <tab :name="'Доходность'">
                <div class="statistica_wrap">
                    <div class="statistica__chart">
                        <div class="statistica__chart-title">График дохода</div>
                        <div class="statistica__chart-wrap">
                            <profitability-chart
                                :symbol="''"
                                :fullStatus="false"
                                :mini="true"
                                :noti="false"
                            ></profitability-chart>
                        </div>
                    </div>
                    <div class="statistica__chart statistica__chart-tabs">
                        <div class="statistica__chart-title">Доход по инструментам</div>
                            <tabs :classTabs = "'mainNavigation'"
                                :classNavigation = "'main-head'"
                                :classItem = "'main-head__tab'"
                                :classActive="'main-head__tab-active'">
                                    <tab :name="'EURUSD'" :selected="true">
                                        <div class="statistica__chart statistica__chart-tab">
                                            <div class="statistica__chart-wrap">
                                                <profitability-chart
                                                    :symbol="'EURUSD'"
                                                    :fullStatus="false"
                                                    :mini="true"
                                                    :noti="false"
                                                ></profitability-chart>
                                            </div>
                                        </div>
                                    </tab>
                                    <tab :name="'GBPUSD'">
                                        <div class="statistica__chart statistica__chart-tab">
                                            <div class="statistica__chart-wrap">
                                                <profitability-chart
                                                    :symbol="'GBPUSD'"
                                                    :fullStatus="false"
                                                    :mini="true"
                                                    :noti="false"
                                                ></profitability-chart>
                                            </div>
                                        </div>
                                    </tab>
                                    <tab :name="'USDJPY'">
                                        <div class="statistica__chart statistica__chart-tab">
                                            <div class="statistica__chart-wrap">
                                                <profitability-chart
                                                    :symbol="'USDJPY'"
                                                    :fullStatus="false"
                                                    :mini="true"
                                                    :noti="false"
                                                ></profitability-chart>
                                            </div>
                                        </div>
                                    </tab>
                                    <tab :name="'USDCHF'">
                                        <div class="statistica__chart statistica__chart-tab">
                                            <div class="statistica__chart-wrap">
                                                <profitability-chart
                                                    :symbol="'USDCHF'"
                                                    :fullStatus="false"
                                                    :mini="true"
                                                    :noti="false"
                                                ></profitability-chart>
                                            </div>
                                        </div>
                                    </tab>
                                    <tab :name="'USDCAD'">
                                        <div class="statistica__chart statistica__chart-tab">
                                            <div class="statistica__chart-wrap">
                                                <profitability-chart
                                                    :symbol="'USDCAD'"
                                                    :fullStatus="false"
                                                    :mini="true"
                                                    :noti="false"
                                                ></profitability-chart>
                                            </div>
                                        </div>
                                    </tab>
                                    <tab :name="'EURGBP'">
                                        <div class="statistica__chart statistica__chart-tab">
                                            <div class="statistica__chart-wrap">
                                                <profitability-chart
                                                    :symbol="'EURGBP'"
                                                    :fullStatus="false"
                                                    :mini="true"
                                                    :noti="false"
                                                ></profitability-chart>
                                            </div>
                                        </div>
                                    </tab>
                            </tabs>
                    </div>
                    <!--<div class="statistica__item">
                        <div class="statistica__item-title">Доход за месяц
                            <span>/ {{getNowDate.month}} {{getNowDate.year}}</span>
                        </div>
                        <sig-month></sig-month>
                    </div>-->
                    <div class="statistica__chart statistica__chart-tabs">
                        <div class="statistica__chart-title">Доход МЕСЯЦ/НЕДЕЛЯ/ДЕНЬ</div>
                            <tabs :classTabs = "'mainNavigation'"
                                :classNavigation = "'main-head'"
                                :classItem = "'main-head__tab'"
                                :classActive="'main-head__tab-active'">
                                    <tab :name="'МЕСЯЦ'" :selected="true">
                                        <div class="statistica__chart statistica__chart-tab">
                                            <div class="statistica__chart-wrap">
                                                <month-cahrt></month-cahrt>
                                            </div>
                                        </div>
                                    </tab>
                                    <tab :name="'НЕДЕЛЯ'">
                                        <div class="statistica__chart statistica__chart-tab">
                                            <div class="statistica__chart-wrap">
                                                <week-chart></week-chart>
                                            </div>
                                        </div>
                                    </tab>
                                    <tab :name="'ДЕНЬ'">
                                        <div class="statistica__chart statistica__chart-tab">
                                            <div class="statistica__chart-wrap">
                                                <day-chart></day-chart>
                                            </div>
                                        </div>
                                    </tab>
                            </tabs>
                    </div>
                    <div class="statistica__chart">
                        <div class="statistica__chart-title">РЕЗУЛЬТАТ ТОРГОВЛИ ЗА 30 ДНЕЙ <!--<span>/{{dateDays.first}} — {{dateDays.last}}</span>--></div>
                        <div class="statistica__chart-wrap">
                            <last-days
                                :noti="false"
                            ></last-days>
                        </div>
                    </div>
                    <div class="statistica__chart">
                        <div class="statistica__chart-title">СРАВНЕНИЕ ДОХОДА ПО ИНСТРУМЕНТАМ</div>
                        <div class="statistica__chart-wrap">
                            <compare></compare>
                        </div>
                    </div>
                    <div class="statistica__item">
                        <profit-year></profit-year>
                    </div>
                    <div class="statistica__chart">
                        <div class="statistica__chart-title">Гистограмма</div>
                        <div class="statistica__chart-wrap">
                            <gistagram></gistagram>
                        </div>
                    </div>
                </div>
            </tab>
            <tab :name="'Позиции'">
                <div class="statistica_wrap">
                    <div class="statistica__open-position">
                        <div class="statistica__open-position-item">
                            <div class="statistica__open-position-item-title">Открытые позиции</div>
                        </div>
                        <div class="statistica__open-position-item">
                            <table>
                                <tr class="statistica__open-position-item-subtitle">
                                    <td class="statistica__open-position-item-subtitle-instrument">инструмент</td>
                                    <td class="statistica__open-position-item-subtitle-open-deal">сделок открыто</td>
                                    <td class="statistica__open-position-item-subtitle-pl">p/l, $</td>
                                    <td class="statistica__open-position-item-subtitle-pl-percent">p/l, %</td>
                                    <td class="statistica__open-position-item-subtitle-pl-pips">p/l, p</td>
                                    <td class="statistica__open-position-item-subtitle-ico"></td>
                                </tr>
                            </table>
                        </div>
                        <accordion
                            :dropdown="false"
                            :icon="'custom'"
                            :caretAnimation="{
                                duration: '.6s',
                                timerFunc: 'ease-in-out',
                            }"
                            :slide="{
                                duration: '.9s',
                                timerFunc: 'ease',
                            }">
                            <accordion-item v-for = "(items, index) in position" :key = "index">
                                <div slot="title">
                                    <title-open-positions :pairData="position[index]"></title-open-positions>
                                </div>
                                <i slot="icon-open" class="icon-icon-up"></i>
                                <i slot="icon-closed" class="icon-icon-down"></i>
                                <div slot="content"><open-positions :pair="position[index]"></open-positions></div>
                            </accordion-item>
                        </accordion>
                    </div>
                    <div class="statistica__open-position">
                        <div class="statistica__open-position-item">
                            <div class="statistica__open-position-item-title">Закрытые позиции </div>
                        </div>
                        <div class="statistica__open-position-item">
                            <table>
                                <tr class="statistica__open-position-item-subtitle">
                                    <td class="statistica__open-position-item-subtitle-instrument">инструмент</td>
                                    <td class="statistica__open-position-item-subtitle-open-deal">сделок закрыто</td>
                                    <td class="statistica__open-position-item-subtitle-lucky-deal">успешных сделок</td>
                                    <td class="statistica__open-position-item-subtitle-pl">p/l, $</td>
                                    <td class="statistica__open-position-item-subtitle-pl-percent">p/l, %</td>
                                    <td class="statistica__open-position-item-subtitle-pl-pips">p/l, p</td>
                                    <td class="statistica__open-position-item-subtitle-ico"></td>
                                </tr>
                            </table>
                        </div>
                        <accordion
                            :dropdown="false"
                            :icon="'custom'"
                            :caretAnimation="{
                                duration: '.6s',
                                timerFunc: 'ease-in-out',
                            }"
                            :slide="{
                                duration: '.9s',
                                timerFunc: 'ease',
                            }">
                            <accordion-item v-for = "(item, index) in getClosePair" :key = "index">
                                <div slot="title">
                                    <title-close-positions :pairName="index" :pairData="item"></title-close-positions>
                                </div>
                                <i slot="icon-open" class="icon-icon-up"></i>
                                <i slot="icon-closed" class="icon-icon-down" @click ="onClosePosPair(index)"></i>
                                <div slot="content">
                                    <close-positions :pair="index" :data="getPositions"></close-positions>
                                </div>
                            </accordion-item>
                        </accordion>
                    </div>
                </div>
            </tab>
            <tab :name="'Прогноз'">
                <div class="statistica_wrap">
                    <prognosis></prognosis>
                </div>
            </tab>
        </tabs>
        </div>
	</scrollbar>
</div>
</template>

<script>
import { mapGetters } from "vuex";
import Vue from 'vue';
import MonthStatistica from './sig-month-statistica'
import OpenPositionsStat from './sig-open-positions-statistica'
import ClosePositionsStat from './sig-close-positions-statistica'
import OpenPositionsStatTitle from './sig-open-positions-title'
import ClosePositionsStatTitle from './sig-close-positions-title'
import QuoteWidgiet from './sig-quote-widget'
import ProfitabilityChart from '../profitability/sig-chart-profit-widget'
import LastDaysChart from './sig-last-days-widget'
import LastDaysMaxdd from './sig-maxdd-last-days'
import MaxDDChart from '../profitability/sig-profitability-chart-maxdd'
import { BulmaAccordion, BulmaAccordionItem } from 'vue-bulma-accordion'
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import PrognosisWidget from './sig-prognosis'
import ProfitOnYaer from './sig-year-profit'
import ProfitGistagram from './sig-year-profit-gistagram'
import Tab from '../ui-components/ui-tab'
import Tabs from '../ui-components/ui-tabs'
import Compare from '../profitability/compare/sig-compare-profitability'
import Summary from './sig-summary-table'
import MonthChart from '../profitability/chartsForTabs/profitMonthCharts/sig-profitability-chart-month'
import DayChart from '../profitability/chartsForTabs/profitDayCharts/profit-day-chart'
import WeekChart from '../profitability/chartsForTabs/profitWeekCharts/sig-profitability-chart-week'

export default {
	components: {
        "sig-month":MonthStatistica,
        "open-positions":OpenPositionsStat,
        "close-positions":ClosePositionsStat,
        "accordion":BulmaAccordion,
        "accordion-item":BulmaAccordionItem,
        "title-open-positions": OpenPositionsStatTitle,
        "title-close-positions": ClosePositionsStatTitle,
        "quots": QuoteWidgiet,
        "profitability-chart": ProfitabilityChart,
        "last-days":LastDaysChart,
        "maxdd-chart": MaxDDChart,
        "prognosis": PrognosisWidget,
        "profit-year":ProfitOnYaer,
        "gistagram":ProfitGistagram,
        "last-days-maxdd":LastDaysMaxdd,
        "tab":Tab,
        "tabs":Tabs,
        "compare":Compare,
        "summary-table":Summary,
        "scrollbar":VuePerfectScrollbar,
        "month-cahrt":MonthChart,
        "day-chart":DayChart,
        "week-chart":WeekChart
    },
	data() {
		return {
            titleClosePositions : ['EURGBP','EURUSD'],
            statPrimary:[],
            summaryEquity:0,
            summaryBalance:0,
            lastDailyEquity:0,
            lastDailyEquityMin:0,
            lastDailyEquityMax:0,
            lastDailyLeverage:0,
            lastDailyLeverageMax:0,
            dd:0,
            leverageMax:0,
            stat:[],
            summaryEquityPrime:0,
            summaryBalancePrime:0,
            lastDailyEquityPrime:0,
            lastDailyEquityMinPrime:0,
            lastDailyEquityMaxPrime:0,
            lastDailyLeveragePrime:0,
            lastDailyLeverageMaxPrime:0,
            ddPrime:0,
            leverageMaxPrime:0,
            delta:0,
            dateDays: {
                first:0,
                last:0,
            }

		};
	},
	computed: {
        ...mapGetters({
            position: "positions/getAllPositions",
            getSummary: 'closSummary/getSummary',
            getPositions: 'closPositions/getPositions',
            //page: 'closPositions/getPage',
		    //total: 'closPositions/getTotal',
		    //pagelen: 'closPositions/getPageLength',
        }),
        getClosePair() {
            let pair = ['AUDUSD','ETHUSD','EURGBP','EURJPY','EURUSD','GBPUSD','NZDUSD','USDCAD','USDCHF','USDJPY','']
            return this.getSummary.SumBySymbol
        },
        getNowDate() {
            let monthes = ['Январь', 'Февраль','Март','Апрель','Май','Июнь','Июль','Август','Сентябрь','Октябрь','Ноябрь','Декабрь'];
            let nowDate = new Date();
            return {month:monthes[nowDate.getMonth()],year: nowDate.getFullYear()};
        },
        deltaBalance()
        {
        return (this.lastDailyBalance1 - this.lastDailyBalance0) / this.lastDailyBalance0 * 100
        },
        deltaEquity()
        {
            return (this.summaryEquity - this.lastDailyEquity ) / this.summaryEquity * 100
        },
	},
	methods: {
		onClosePosPair(pairName) {
            let query = { pageLength: 20, page: 0, symbol: pairName }
            this.$store.dispatch("closPositions/readPositionsFromServer", query)
        },
        proccesStatisticReady(symbol){
            let stat = this.$store.getters["accountstat/getStatistics"](symbol);
            this.statPrimary = stat;
            this.summaryEquity = this.statPrimary.DailyRecords[this.statPrimary.DailyRecords.length - 1].EquityClose;
            this.summaryBalance = this.statPrimary.DailyRecords[this.statPrimary.DailyRecords.length - 1].BalanceClose;
            this.lastDailyEquityMax = this.statPrimary.DailyRecords[this.statPrimary.DailyRecords.length - 1].EquityHigh;
            this.lastDailyEquityMin = this.statPrimary.DailyRecords[this.statPrimary.DailyRecords.length - 1].EquityLow;
            this.lastDailyEquity = this.statPrimary.DailyRecords[this.statPrimary.DailyRecords.length - 1].EquityOpen;
            this.lastDailyLeverage = this.statPrimary.DailyRecords[this.statPrimary.DailyRecords.length - 1].Leverage;
            this.lastDailyLeverageMax = this.statPrimary.DailyRecords[this.statPrimary.DailyRecords.length - 1].LeverageHigh;
            this.leverageMax = this.statPrimary.Summary.MaxLeverage;
            this.dd = this.statPrimary.DailyRecords[this.statPrimary.DailyRecords.length - 1].Drawdown;
        },
        proccesStatisticReadyPrime(symbol) {
            let stat = this.$store.getters["accountstat/getStatistics"](symbol);
            this.summaryEquityPrime = stat.DailyRecords[stat.DailyRecords.length - 1].EquityClose;
            this.summaryBalancePrime  = stat.DailyRecords[stat.DailyRecords.length - 1].BalanceClose;
            this.lastDailyEquityMaxPrime  = stat.DailyRecords[stat.DailyRecords.length - 1].EquityHigh;
            this.lastDailyEquityMinPrime  = stat.DailyRecords[stat.DailyRecords.length - 1].EquityLow;
            this.lastDailyEquityPrime  = stat.DailyRecords[stat.DailyRecords.length - 1].EquityOpen;
            this.lastDailyLeveragePrime  = stat.DailyRecords[stat.DailyRecords.length - 1].Leverage;
            this.lastDailyLeverageMaxPrime  = stat.DailyRecords[stat.DailyRecords.length - 1].LeverageHigh;
            this.leverageMaxPrime  = stat.Summary.MaxLeverage;
            this.ddPrime  = stat.DailyRecords[stat.DailyRecords.length - 1].Drawdown
            this.delta = (this.summaryEquityPrime - this.lastDailyEquityPrime ) / this.summaryEquityPrime * 100
        },
        setDays(days) {
            this.dateDays.first = days.first;
            this.dateDays.last = days.last;
        }
    },
    created() {
        this.$store.dispatch("closSummary/initialize")
    }

};
</script>

<style lang="less" scoped>
.profile_blockWidget {
    display: flex;
    width: 360px;
    background: #3D536B;
    margin-bottom: 4px;
    &-image {
        display: flex;
        border-bottom: solid 1px #293546;
        height: 179px;
        display: flex;
        align-items: center;
        padding-left: 12px;
    }
    &-imageItem {
        height: 155px;
        width: 109px;
        margin-right: 12px;
    }
    &-header {
      background: #3D536B;
      width: 100%;
      display: flex;
      height: 172px;
      padding: 0 23px 0 23px;
      box-sizing: border-box;
    }
    &-center {
        display: flex;
        margin-top: 4px;
        height: calc(100vh - 275px);
        overflow: hidden;
        //margin-bottom: 4px;
    }
    &-chat {
        display: flex;
        flex-direction: column;
        min-height: 100%;
        overflow: hidden;
        background: #293546;
    }
    &-chatWidget {
        //flex-grow: 1;
        //max-height: 100%;
        //flex-basis: 100%;
    }
    &-chatForms {
        //flex-grow: 1;
        //flex-basis: 100%;
    }
    &-profitDeals {
        display: flex;
        justify-content: space-between;
        &_wrapData {
            padding: 8px 16px;
        }
        &-title {
            font-family: Montserrat;
            font-size: 11px;
            font-weight: 600;
            font-style: normal;
            font-stretch: normal;
            line-height: 2.18;
            letter-spacing: .4px;
            text-transform: uppercase;
            color: #fff;
            margin-top: 4px;
        }
        &-chart {
            flex-grow: 1;
            max-width: 180px;
            padding: 8px 16px;
            display: flex;
            justify-content: flex-end;
        }
    }
    &-profitWidget {
        min-width: 360px;
        height: calc(100vh - 264px);
        overflow: auto;
    }
    &-chart {
        max-width: 100%;
        height: 480px;
        flex-grow: 1;
        @media (max-width: 1690px) {
            height: 404px;
        }
        @media (min-width: 1930px) {
            height: calc(100vh - 804px);
        }
        &:first-child {
            margin-bottom: 3px;
        }
    }
    &-chartWrap {
        flex-grow: 1;
        margin-left: 4px;
        height: calc(100vh - 275px);
        overflow: auto;
    }
    &-chartPrognosis {
        display: flex;
        width: 100%;
        max-height: 245px;
        border-top: solid #293546 4px;
        &_item {
            flex-basis: 50%;
            flex-grow: 1;
            height: 245px;
            &:first-child {
                border-right: solid #293546 4px;
            }
        }
    }
    &-trader {
        align-items: center;
        display: flex;
        width: 45%;
        padding-right: 40px;
        box-sizing: border-box;
        justify-content: space-between;
        border-right: solid #293546 1px;
        @media (max-width: 1690px) {
            width: 50%;
        }

    }
    &-traderAva {
        width: 125px;
        height: 125px;
        border-radius: 70px;
        overflow: hidden;
        @media (max-width: 1690px) {
            width: 80px;
            height: 80px;
            margin-right: 12px;
        }
    }
    &-traderName {

    }
    &-name {
        font-family: Montserrat;
        font-style: normal;
        font-weight: 600;
        font-size: 22px;
        line-height: 20px;
        letter-spacing: 0.4px;
        color: #FFFFFF;
        margin-bottom: 20px;
        @media (max-width: 1690px) {
            font-size: 18px;
        }
    }
    &-status {
        font-family: Montserrat;
        font-style: normal;
        font-weight: 500;
        font-size: 17px;
        line-height: 16px;
        letter-spacing: 0.4px;
        color: #ADC4E1;
        @media (max-width: 1690px) {
             font-size: 14px;
        }
    }
    &-traderSkils {
        display: flex;
        flex-grow: 1;
        align-items: center;
        justify-content: center;
        &-wrap {
            display: flex;
            justify-content: space-between;
            max-width: 100%;
            padding-left: 23px;
        }
    }
    &-traderSkilsUl {
        font-family: Montserrat;
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 20px;
        /* or 143% */
        letter-spacing: 0.4px;
        max-width: 45%;
        margin-left: 23px;
    }
    &_vertikal {
        display: block;
    }
    &_big {
        height: 120px;
        &-column {
            flex-direction: column;
        }
    }
    &_mini {
        height: 70px;
    }
    &-text {
        padding: 12px;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        &_prognosis {
           border-top: 1px solid #293546;
        }
    }
    &-row {
        width: 100%;
        display: flex;
        justify-content: space-between;
        border-top: 1px solid #293546;
    }
    &-col {
        width: 50%;
        flex-grow: 1;
        padding: 12px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-right: 1px solid #293546;
        font-family: Arimo;
        font-style: normal;
        font-weight: bold;
        font-size: 10px;
        line-height: 14px;
        /* identical to box height, or 140% */
        letter-spacing: 0.4px;
        color: #FFFFFF;
        &-left {
            justify-content: flex-start;
            span:last-child {
                margin-left: 6px;
            }
        }
        &:last-child {
           border-right:none;
        }
    }
    &-title {
        font-family: Arimo;
        font-style: normal;
        font-weight: bold;
        font-size: 12px;
        line-height: 20px;
        /* identical to box height, or 167% */
        letter-spacing: 0.4px;
        text-transform: uppercase;
        color: #FFFFFF;
        margin-bottom: 12px;
        &_noBottom {
            margin-bottom: 0;
        }
        &_prognosis {
            font-family: Arimo;
            font-style: normal;
            font-weight: bold;
            font-size: 14px;
            /* or 267% */
            letter-spacing: 0.4px;
            text-transform: uppercase;
            color: #00FFD0;
        }
    }
    &-subtitle {
        font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        font-size: 13px;
        line-height: 15px;
        color: #ADC4E1;
        a {
           color: #ADC4E1;
        }
        &-link {
            text-transform: uppercase;
            cursor: pointer;
        }
    }
    &-bigIcon {
        padding: 20px;
        border-right: 1px #293546 solid;
    }
    &-ico {
        color:#718DA8;
        cursor: pointer;
    }
}
.gorizontal {
    flex-direction: row;
    width: 100%;
    align-items: center;
}
.statistica__gistagramma {
    background: #3d536b;
    border-radius: 4px;
}
.statistica__chart {
    min-width: 1080px;
    height: 700px;
    display: flex;
    flex-direction: column;
    background-color: #324258;
    border-radius: 4px;
    margin-top: 40px;
    &-tab  {
        margin-top: 0px;
    }
    &-tabs {
        height: 100%;
    }
    &-title {
        font-family: Montserrat;
        font-size: 16px;
        font-weight: bold;
        font-style: normal;
        font-stretch: normal;
        line-height: 2.2;
        letter-spacing: 0.4px;
        text-transform: uppercase;
        padding: 0 12px;
        color: #fff;
        height: 40px;
    }
    &-wrap {
        flex-grow: 1;
        flex-basis: 100%;
		height: 100%;
    }

    span {
        font-family: Montserrat;
        font-size: 16px;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: 3;
        letter-spacing: 0.4px;
        text-align: left;
        color: #aabed2;
    }
}
.statistica_wrap {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    margin: 0 auto;
    padding-bottom: 10px;
}
.statistica__item
{
    background-color: #324258;
    border-radius: 4px;
    width: 912px;
    margin-top: 40px;
    overflow: hidden;
    &-gistagram {
        display: flex;
        flex-direction: column;
        min-height: 700px;
        flex-grow: 1;
        min-width: 912px;
        background-color: #324258;
    }
    &-title
    {
        font-family: Montserrat;
        font-size: 16px;
        font-weight: bold;
        font-style: normal;
        font-stretch: normal;
        line-height: 3;
        letter-spacing: 0.4px;
        color: #ffffff;
        text-transform: uppercase;
        padding-left: 12px;

        span {
            font-weight: 500;
            color: #aabed2;
            margin-left: 12px;
            text-transform: none;
        }
    }
}

.statistica__closed-position {
    width: 912px;
    background-color: #324258;
    display: block;
    color: #fff;
    border-radius: 4px;
    margin-top:40px;
    margin-bottom: 40px;
}

.statistica__open-position {
    display: block;
    color: #fff;
    border-radius: 4px;
    margin-top: 40px;
    width: 1000px;
    &-item {
        border-bottom: 1px solid #374B62;
        position: relative;
        background: #3D536B;
        &-title {
            font-family: Montserrat;
            font-size: 16px;
            font-weight: bold;
            font-style: normal;
            font-stretch: normal;
            line-height: 3;
            letter-spacing: 0.4px;
            text-transform: uppercase;
            padding: 0 12px;
        }

        &-subtitle {
            font-family: Arimo;
            font-size: 11px;
            font-weight: bold;
            font-style: normal;
            font-stretch: normal;
            line-height: 3.64;
            letter-spacing: 0.4px;
            color: #adc7e1;
            text-transform: uppercase;
            display: flex;
            justify-content: space-between;

            &-instrument {
                width: 152px;
                padding-left: 12px;
                box-sizing: border-box;
            }

            &-open-deal {
                width: 160px;
                //padding-left: 12px;
                box-sizing: border-box;
            }

            &-lucky-deal {
                width: 142px;
                text-align: right;
            }

            &-pl {
                width: 135px;
                //padding-right: 12px;
                text-align: right;
                box-sizing: border-box;
            }

            &-pl-percent {
                width: 135px;
                //padding-right: 12px;
                text-align: right;
                box-sizing: border-box;
            }

            &-pl-pips {
                width: 135px;
                //padding-right: 12px;
                text-align: right;
                box-sizing: border-box;
            }
            &-ico {
                width:23px;
            }
        }
    }
}
table {
    width:calc(100% - 31px);
}
.statistica__content {
width: 912px;
display: block;
background-color: #324258;
color: #fff;
border-radius: 4px;
padding: 0 12px 12px 12px;
font-family: Roboto;
font-size: 15px;
font-weight: normal;
font-style: normal;
font-stretch: normal;
line-height: 1.6;
letter-spacing: normal;
text-align: left;
color: #ffffff;
box-sizing: border-box;
margin-bottom: 40px;
margin-top:40px;

h1 {
    font-family: Montserrat;
font-size: 16px;
font-weight: bold;
font-style: normal;
font-stretch: normal;
line-height: 3;
letter-spacing: 0.4px;
text-transform: uppercase;
margin-bottom: -12px;
}

p {
    margin: 12px 0 12px 0;
}

}

.read-more {
font-family: Arimo;
font-size: 13px;
font-weight: bold;
font-style: normal;
font-stretch: normal;
line-height: 1.85;
letter-spacing: 0.4px;
text-transform: uppercase;
color: #adc4e1;
display: flex;
align-items: center;
cursor: pointer;

&__ico {
margin-left: 12px;
font-size: 18px;
line-height: 1;
}
}

</style>
